import { type SxProps, type Theme, Button } from "@mui/material";
import { type PickersActionBarAction, MobileDatePicker } from "@mui/x-date-pickers";
import React, { useState } from "react";

import { ariaLabel as ariaLabelConst } from "src/constants";

import { DatePickerToolbar } from "./DatePickerToolbar";
import { DatePickerButtonStyle } from "./styles";

interface Props {
  ariaLabel?: string;
  ariaLabelledBy?: string;
  ariaDescribedBy?: string;
  clearable?: boolean;
  error?: boolean;
  label?: string;
  maxDate?: Date;
  minDate?: Date;
  placeholder?: string;
  sx?: SxProps<Theme>;
  value?: Date | null;
  onChange: (date: Date | null) => void;
  id?: string;
}

export const DatePicker = ({
  ariaLabel,
  ariaLabelledBy,
  ariaDescribedBy,
  clearable,
  error,
  label,
  maxDate,
  minDate,
  placeholder,
  sx,
  value,
  onChange,
  id,
}: Props) => {
  const [open, setOpen] = useState(false);
  const actionBarActions: Array<PickersActionBarAction> = [];
  if (clearable) {actionBarActions.push("clear");}
  actionBarActions.push("cancel", "accept");

  return (
    <MobileDatePicker
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      label={label}
      value={value}
      onChange={onChange}
      minDate={minDate}
      maxDate={maxDate}
      views={["year", "month", "day"]}
      sx={sx}
      slots={{
        toolbar: () => <DatePickerToolbar value={value} />,
        textField: () => (
          <Button
            onClick={() => setOpen(true)}
            id={id}
            aria-label={ariaLabel}
            aria-labelledby={ariaLabelledBy}
            aria-describedby={ariaDescribedBy}
            sx={DatePickerButtonStyle(error, value, sx)}
          >
            {value?.toLocaleDateString() || placeholder || label || "ex : 01/01/2025"}
          </Button>
        ),
      }}
      slotProps={{
        actionBar: {
          actions: actionBarActions,
        },
        mobilePaper: {
          "aria-label": ariaLabel || ariaLabelConst.datePickerDialog,
          "aria-labelledby": ariaLabelledBy,
        },
        dialog: {
          "aria-label": ariaLabel || ariaLabelConst.datePickerDialog,
          "aria-labelledby": ariaLabelledBy,
        },
        switchViewButton: {
          "aria-label": ariaLabelConst.datePickerSwitchViewButton,
        },
        leftArrowIcon: {
          "aria-label": ariaLabelConst.datePickerLeftArrowIcon,
        },
        rightArrowIcon: {
          "aria-label": ariaLabelConst.datePickerRightArrowIcon,
        },
      }}
    />
  );
};
